<template>
  <module-list-layout :createAction="createAction" :module="module" class="p-2" v-if="amReady">

    <el-dialog :visible.sync="createUserDialog" title="" top="5vh" width="75%">
      <userCreateForm
          :autoBind="false"
          :bindingForView="false"
          :dataToBind="userData"
          :edit-mode="false"
          :formHeader="true"
          :isForCurrentActiveUser="false"
          :on-create-callback="afterCreate"
          :on-edit-callback="afterEdit"
          :showPasswordField="true"
          class="p-3"
          v-if="createUserDialog"></userCreateForm>
    </el-dialog>

    <el-dialog :visible.sync="dialogVisible" title="" top="5vh" width="75%">
      <moduleForm
          :autoBind="false"
          :bindingForView="true"
          :dataToBind="dataToBind"
          :edit-mode="editMode"
          :formHeader="true"
          :formTitle="((editMode)? 'Update ' : 'Create ') + module.info.caption"
          :moduleDeleteAction='moduleFormDeleteAction'
          :on-create-callback="afterCreate"
          :on-edit-callback="afterEdit"
          v-if="dialogVisible"></moduleForm>
    </el-dialog>

    <div class="row pl-3 pr-3">
      <div class="col-12 col-md-6 pt-1">
        <dg-text-field
            :field_span="22"
            :label_span="22"
            :liveUpdate="true"
            @amUpdated="userSearchUpdated"
            field_mark=""
            placeholder="search here"></dg-text-field>
      </div>
      <div class="col-12 col-md-6  pt-1">
        <pagination
            :currentPage="currentPage"
            :navigateHandler="navigateToPage"
            :page-count="getPagesCount()"
            paginateClass=""></pagination>
      </div>
    </div>

    <app-ag-grid :agGrid="agGrid"></app-ag-grid>

    <el-dialog :visible.sync="deleteDialogVisible" center title="Warning" width="420px">
      <div align="center" class="mt-2 mb-2">You want to remove this record ?</div>
      <span class="dialog-footer" slot="footer">
        <el-button @click="deleteDialogVisible = false" size="small">Cancel</el-button>
        <el-button @click="removeActionApi" size="small" type="danger">Yes</el-button>
      </span>
    </el-dialog>
  </module-list-layout>
</template>

<script>

import actionsCell from './ag-grid/ActionsCell'
import module from './../../index.js'
import {notify} from '@/system-services/notify.js'


export default {
  components: {
    pagination: () => import('@/components/pagination/View.vue'),
    moduleForm: () => import('../../form/View'),
    moduleListLayout: () => import('@/modules-config/layouts/list/View.vue'),
    userCreateForm: () => import('@/modules/user/form/View')
  },
  data() {
    return {
      userData: {},
      createUserDialog: false,
      deleteDialogVisible: false,
      targetParams: null,
      userSearch: '',
      userSearchTimeOut: null,
      amReady: false,
      module: {
        ...module
      },
      currentPage: 1,
      pageChunkSize: 12,
      pageCount: 1,
      editMode: false,
      dialogVisible: false,
      recordsCounter: 0,
      dataToBind: null,
      rowToEdit: null,
      agGrid: {
        pagination: false,
        enableRtl: this.$langConfig.dir == 'rtl',
        agGridStyle: 'width: 100%; height: 650px; padding: 0',
        agGridClass: 'ag-theme-material',
        gridOptions: {
          suppressCellSelection: true,
          onGridReady: function (params) {
            params.api.sizeColumnsToFit()
          }
        },
        columnDefs: [
          {
            field: 'legal_company_name',
            headerName: 'Legal Company Name',
            headerClass: this.$langConfig.lang + '-lang-text text-capitalize',
            cellClass: 'text-capitalize'
          },
          {
            field: 'corporate_type',
            headerName: 'Corporate Type',
            headerClass: this.$langConfig.lang + '-lang-text text-capitalize',
          },
          {
            field: 'full_contact_name',
            headerName: 'Full Contact Name',
            headerClass: this.$langConfig.lang + '-lang-text text-capitalize',
          },
          {
            field: 'created_at',
            headerName: 'Signed Date',
            headerClass: this.$langConfig.lang + '-lang-text text-capitalize',
            cellRenderer: (params) => {
              let span = document.createElement('span')
              // span.style.color = params.color
              span.innerText = params.data.created_at
              return span
            },
            cellRendererParams: {
              color: 'orange'
            }
          },
          {
            width: 100,
            field: 'signup_request_status',
            headerName: 'Status',
            headerClass: this.$langConfig.lang + '-lang-text text-capitalize',
            cellRenderer: (params) => {
              let config = this.getSignupRequestStatusConfig(params.data.signup_request_status)
              let span = document.createElement('span')
              span.setAttribute('class', config.cssClass)
              span.innerText = config.label
              return span
            },
            cellRendererParams: {
              color: 'orange'
            }
          },
          {
            width: 120,
            headerName: this.$ml.get('actions'),
            headerClass: this.$langConfig.lang + '-lang-text text-capitalize',
            cellRendererFramework: $vue.extend(actionsCell),
            cellRendererParams: {
              props: {
                actionsHandler: this.actionsHandler
              }
            }
          }
        ],
        rowData: []
      }
    };
  },
  beforeMount() {
    this.currentPage = parseInt(this.$route.params.listPage)
    this.getEntityListData(this.currentPage)
  },
  methods: {
    createUserFromRecord (agGridParams) {
      let cmp = agGridParams.data.legal_company_name.replace(/ /g, '')
      this.userData = {
        username: agGridParams.data.legal_company_name.replace(/ /g, ''),
        display_name: agGridParams.data.legal_company_name,
        email: agGridParams.data.support_email,
        user_profile_id: '6',
        user_code:agGridParams.data.user_code,
        password: cmp.substr(1, 1).toUpperCase() + cmp.substr(1, 3) + '@321',
        _showPassword_: true,
        '_NEW_USER_': true
      }
      this.createUserDialog = true
    },
    getSignupRequestStatusConfig(status_id) {
      let s = status_id;
      if (s == 1) return {
          label: "New",
          cssClass: 'btn btn-info btn-sm'
      }

      if (s == 2) return {
        label: "Approved",
        cssClass: 'btn btn-success btn-sm'
      }

      if (s == 3) return {
        label: "Incorrect",
        cssClass: 'btn btn-danger btn-sm'
      }


    },
    getEntityListData(page) {
      this.getEntityList({page: page, search: this.userSearch}).then(response => {
        this.buildAgGridData(response)
      })
      this.currentPage = page
    },
    buildAgGridData(response) {
      this.agGrid.rowData = response.rows
      this.recordsCounter = response.count
      this.amReady = true
    },
    userSearchUpdated(field) {
      // this.agGrid.gridApi.setQuickFilter(val);
      let val = field.field.field_value
      this.userSearch = val
      clearTimeout(this.userSearchTimeOut)
      this.userSearchTimeOut = setTimeout(() => {
        this.getEntityListData(1) //this.agGrid.gridApi.setQuickFilter(val);
      }, 200)
    },
    ...$mapActions('form_sign_up_fas_free_routes-api', {getEntityList: 'list'}),
    scrollToTop() {
      document.body.scrollTop = 0;
      document.getElementById('content-main-container').scrollTop = 0;
    },
    getPagesCount() {
      return Math.ceil(this.recordsCounter / this.pageChunkSize)
    },
    navigateToPage(page) {
      $router.push({name: this.module.info.routeName + '->list->page', params: {listPage: page}})
    },
    refreshGrid() {
      this.agGrid.gridOptions.api.setRowData(this.agGrid.rowData)
    },
    afterEdit(updatedData, propertyName = false, closeDialog = true) {
      // getting a rowNode by index
      // this.agGrid.gridApi.getDisplayedRowAtIndex(0).setData({})

      if (propertyName) {
        this.agGrid.rowData[this.rowToEdit][propertyName] = updatedData;
      } else {
        this.agGrid.rowData[this.rowToEdit] = updatedData;
      }

      if (closeDialog) this.dialogVisible = false;
      this.refreshGrid();
    },
    moduleFormDeleteAction() {
      this.removeAction({
        data: this.dataToBind,
        rowIndex: this.rowToEdit
      })
      this.dialogVisible = false;
    },
    afterCreate(newEntity) {
      this.agGrid.rowData.push(newEntity);
      this.dialogVisible = false;
      this.refreshGrid();
    },
    createAction(params) {
      this.dialogVisible = true;
      this.editMode = false;
      this.dataToBind = null;
      this.rowToEdit = null;
      // this.$router.push({ name: this.module.info.routeName + '->view', params: { id: params.data.id}})
    },
    editAction(params) {
      this.dialogVisible = true;
      this.editMode = true;
      this.dataToBind = params.data;
      this.rowToEdit = params.rowIndex;
    },
    removeAction(params) {
      this.targetParams = params
      this.deleteDialogVisible = true
    },
    removeActionApi() {
      let params = this.targetParams
      this.deleteDialogVisible = false
      this.$store.dispatch('form_sign_up_fas_free_routes-api/remove', {id: params.data.id}).then(response => {
        this.agGrid.rowData.splice(params.rowIndex, 1);
        this.refreshGrid();
        this.recordsCounter -= 1;
        notify({
          type: 'success',
          title: this.$ml.get('deleted'),
        });
      })
    },
    actionsHandler(command, params) {
      this[command](params)
    }
  }
}
</script>
